import React from 'react';
import PropTypes from 'prop-types';
import InputWithLabelV2 from '../../../../components/composite/FormSets/InputWithLabelV2/InputWithLabelV2';
import { setFieldAndValidate } from '../../../../utils/field-utils';
import { userFieldSchemas } from '../../../../utils/validation-utils';

const EmailPasswordControlSet = ({
  email,
  setEmail,
  password,
  setPassword,
}) => (
  <>
    <InputWithLabelV2
      id="email"
      label="Email"
      value={email.value || ''}
      maxLength="150"
      type="email"
      errorMsg={email.error || ''}
      onChange={({ target: { value } }) => setFieldAndValidate(email, setEmail, value, userFieldSchemas.email)}
    />

    <InputWithLabelV2
      id="password"
      label="Password"
      value={password || ''}
      maxLength="72"
      type="password"
      onChange={({ target: { value } }) => setPassword(value)}
    />
  </>
);

EmailPasswordControlSet.propTypes = {
  email: PropTypes.shape({
    value: PropTypes.string.isRequired,
    state: PropTypes.number.isRequired,
    error: PropTypes.string,
  }).isRequired,
  setEmail: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  setPassword: PropTypes.func.isRequired,
};

export default EmailPasswordControlSet;
